/* eslint-disable no-console */

// Service Worker deshabilitado para evitar problemas de caché de versiones antiguas
// Si necesitas habilitarlo en el futuro, asegúrate de configurar correctamente
// la estrategia de actualización y el service-worker.js

// import { register } from "register-service-worker";

// if (process.env.NODE_ENV === "production") {
//   register(`${process.env.BASE_URL}service-worker.js`, {
//     ready() {
//       console.log(
//         "App is being served from cache by a service worker.\n" +
//           "For more details, visit https://goo.gl/AFskqB"
//       );
//     },
//     registered() {
//       console.log("Service worker has been registered.");
//     },
//     cached() {
//       console.log("Content has been cached for offline use.");
//     },
//     updatefound() {
//       console.log("New content is downloading.");
//     },
//     updated() {
//       console.log("New content is available; please refresh.");
//     },
//     offline() {
//       console.log(
//         "No internet connection found. App is running in offline mode."
//       );
//     },
//     error(error) {
//       console.error("Error during service worker registration:", error);
//     },
//   });
// }

// Desregistrar service workers existentes para limpiar caché antiguo
if (typeof navigator !== "undefined" && "serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    for (const registration of registrations) {
      // El SW de notificaciones del chat (/chat, sin caché) se queda: ver public/agent-chat-sw.js.
      if (
        String(registration.scope || "")
          .replace(/\/$/, "")
          .endsWith("/chat")
      )
        continue;
      registration.unregister().then((success) => {
        if (success) {
          console.log("Service Worker desregistrado para evitar caché antiguo");
        }
      });
    }
  });
}
